module.exports = __webpack_public_path__ + "cornerSprite-02888f2fe6748ffef86f66b890a2ac44.png";